import PageTitle from "../../../Components/UI/PageTitle";
import AddOrEditInstructor from "../../../Components/InstructorsModule/AddOrEditInstructor";

const AddNewInstructor = () => {
  return (
    <>
      <PageTitle
        title={"Add New Instructor"}
        BreadcrumbItems={[
          {
            title: "Home",
            link: "/",
          },
          {
            title: "Instructors Management",
            link: "/instructors-management",
          },
          {
            title: "Add New Instructor",
          },
        ]}
      />
      <AddOrEditInstructor mode="add" />
    </>
  );
};

export default AddNewInstructor;
